<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/teachers/index')">mdi-arrow-left</v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>ویرایش استاد</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-text-field color="black" v-model="teacher.name" label="نام و نام خانوادگی"></v-text-field>
          </v-col>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-text-field color="black" v-model="teacher.email" label="ایمیل" type="email"></v-text-field>
          </v-col>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-text-field label="شماره همراه" color="black" v-model="teacher.mobile"></v-text-field>
          </v-col>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-text-field color="black" v-model="teacher.password" label="رمز عبور"></v-text-field>
          </v-col>
          <v-col cols="6" md="2" lg="2" sm="6">
            <v-select label="جنسیت" :items="[{text:'مرد',value:'male'},{text:'زن',value:'female'}]"
                      color="black" v-model="teacher.gender">
            </v-select>
          </v-col>
          <v-col cols="6" md="2" lg="2" sm="6">
            <v-select label="وضعیت" :items="[{text:'فعال',value:'active'},{text:'در انتظار تایید',value:'waiting'}]"
                      color="black" v-model="teacher.status"></v-select>
          </v-col>
          <v-col>
            <v-select :items="states" label="استان" item-text="label" item-value="id" color="black"
                      v-model="teacher.state_id"
                      @change="getCities"></v-select>
          </v-col>
          <v-col>
            <v-select :items="cities" label="شهر" item-text="label" item-value="id" color="black"
                      v-model="teacher.city_id"></v-select>
          </v-col>
          <v-col>
            <v-select label="آموزشگاه" :items="schools" item-text="label" item-value="id" color="black"
                      v-model="teacher.school_id"></v-select>
          </v-col>
          <v-col cols="12">
            <v-textarea color="black" v-model="teacher.details" hint="در داشبورد کاربر نمایش داده می شود."
                        label="اطلاعات مربی"></v-textarea>
          </v-col>
          <v-col cols="12">
            <v-text-field label="عکس پروفایل"
                          @click="openFileDialog()" prepend-icon="mdi-plus"
                          color="black"
                          v-model="teacher.profile_image"></v-text-field>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn block color="success" class="normal-font-btn" @click="update()">ویرایش</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="uploadFileDialog" max-width="50vw">
      <drag-and-drop module="teacher" ref="image-uploader" @closeUploadFileDialog="uploadFileDialog = false"
                     @changeFile="teacher.profile_image = $event"></drag-and-drop>
    </v-dialog>
  </div>
</template>

<script>
import DragAndDrop from "@/components/UploadFile/DragAndDrop";

export default {
  name: "TeacherEdit",
  components: {DragAndDrop},
  data() {
    return {
      uploadFileDialog: false,
      states: [],
      cities: [],
      schools: [],
      teacher: {
        name: null,
        email: null,
        password: null,
        gender: 'male',
        mobile: null,
        profile_image: null,
        state_id: null,
        city_id: null,
        school_id: null,
        status: null,
        details: null
      }
    }
  },
  mounted() {
    this.getTeacher()
    this.getStates()
    this.getSchools()
  },
  methods: {
    update() {
      window.axios.post('admin/instructor/update/' + this.$route.params.id, this.teacher).then(() => {
        this.openSnackbar("استاد مورد نظر با موفقیت ویرایش شد.", 'success')
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    getTeacher() {
      window.axios.get('admin/instructor/get/' + this.$route.params.id).then((res) => {
        this.teacher = res.data.data
        this.getCities()
      })
    },
    openFileDialog() {
      this.uploadFileDialog = true
    },
    getStates() {
      window.axios.get('system/state/index').then((res) => {
        this.states = res.data.data
      })
    },
    getCities() {
      window.axios.get('system/city/index?state_id=' + this.teacher.state_id).then((res) => {
        this.cities = res.data.data
      })
    },
    getSchools() {
      window.axios.get('school/admin-index').then((res) => {
        this.schools = res.data.data
      })
    }
  }
}
</script>

<style scoped>

</style>